import React, { Component } from "react";
import { List, InputItem, Button, Toast } from "antd-mobile";
import { getItem, setItem, fixIOSWXBug } from "../../util/util";
import http from "../../util/api";
import qs from "qs";
import { createForm } from "rc-form";
import "./Register.scss";
import Countdown from "../../components/Countdown";
import moment from "moment";
const { Fragment } = React;

class Register extends Component {
  state = {
    hasGetVerCodeBtn: true,
  };

  componentDidMount = async () => {
    const search = document.location.search;
    const querystring = search.substring(1);
    let { invitecode } = qs.parse(querystring);
    let { unionid, openid, nickname, headurl } = qs.parse(querystring);
    if (unionid && openid) {
      setItem("unionid", unionid);
      setItem("openid", openid);
      setItem("nickname", nickname);
      setItem("headurl", headurl);
    } else {
      unionid = getItem("unionid");
      openid = getItem("openid");
    }
    this.unionid = unionid;
    this.openid = openid;
    if (invitecode) {
      this.invitecode = invitecode;
      if (!getItem("unionid")) {
        return (document.location.href = `${window.authBaseUrl}${
          window.returnRegisterURL
        }?invitecode=${invitecode}`);
      }
    }
  };

  handleSubmit = () => {
    const { validateFields } = this.props.form;
    validateFields(async (err, values) => {
      if (err) {
        return Toast.fail("信息填写有误");
      }
      Toast.loading("注册中...", 0);
      const userid = values.phoneNumber + moment().format("YYYYMM");
      let registerData = {
        Handphone: values.phoneNumber, // 手机号
        userid: userid, //身份证号
        // personid: values.idNumber,
        validCode: values.verifyCode, // 验证码
        nickname: values.phoneNumber, // 昵称
        validresid: 616852937051,
        unionid: this.unionid,
        openid: this.openid,
      };
      if (this.invitecode) {
        registerData.invitecode = this.invitecode;
      }
      let loginData = {
        mobileno: values.phoneNumber, // 手机号
        validCode: values.verifyCode, // 验证码
        loginMethod: "mobile",
        useCookie: false,
      };
      try {
        //是否已注册
        let isUserExistResponse = await this.isUserExist(userid);
        if (isUserExistResponse.data.onedata) {
          return Toast.fail("该手机号已注册");
        }
        await this.register(registerData);
        // 注册成功
        Toast.success("注册成功！自动登录中...");
        this.login(loginData, values.idNumber);
      } catch (error) {
        Toast.fail(error.message);
      }
    });
  };

  isUserExist = async (userid) => {
    try {
      let res = await http().isUserExist({ userid });
      return res;
    } catch (error) {
      throw error;
    }
  };

  //注册
  register = async (data) => {
    try {
      let res = await http().register(data);
      return res;
    } catch (error) {
      throw error;
    }
  };

  // 登录
  login = async (data, id) => {
    try {
      let res = await http().login(data);
      setItem("userInfo", JSON.stringify(res.data));
      Toast.success("登录成功！");
      this.props.history.push("/home");
    } catch (error) {
      throw error;
    }
  };

  handleGetVerifyCode = async () => {
    const { getFieldValue, getFieldError } = this.props.form;
    const phoneNumber = getFieldValue("phoneNumber");
    const hasError = getFieldError("phoneNumber");
    if (!phoneNumber || hasError) {
      return Toast.fail("手机号格式有误", 1);
    }
    let res;
    try {
      res = await http().getVerCode({
        telephone: phoneNumber,
        unionid: this.unionid,
        openid: this.openid,
      });
      Toast.info("已发送验证码");
      this.setState({ hasGetVerCodeBtn: false });
    } catch (err) {
      return Toast.fail(err.message);
    }
    // 获取验证码成功
    if (res.data.error === 0) {
      Toast.info("已发送验证码");
      this.setState({ hasGetVerCodeBtn: false });
    } else {
      Toast.fail(res.data.message);
    }
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    const { hasGetVerCodeBtn } = this.state;
    return (
      <div className="register">
        <div style={{ height: "100%", marginTop: "10%" }}>
          <List>
            <InputItem
              placeholder="请输入手机号"
              type="number"
              {...getFieldProps("phoneNumber", {
                rules: [{ required: true, len: 11 }],
              })}
              onBlur={fixIOSWXBug}
              error={getFieldError("phoneNumber")}
              extra={
                <Fragment>
                  {hasGetVerCodeBtn ? (
                    <span
                      className="register__get-verify-code-btn"
                      onClick={this.handleGetVerifyCode}
                    >
                      获取验证码
                    </span>
                  ) : (
                    <Countdown
                      onDownEnd={() =>
                        this.setState({ hasGetVerCodeBtn: true })
                      }
                    />
                  )}
                </Fragment>
              }
            />
            <InputItem
              placeholder="请输入验证码"
              {...getFieldProps("verifyCode", {
                rules: [{ required: true }],
              })}
              onBlur={fixIOSWXBug}
              error={getFieldError("verifyCode")}
            />
            {/* <InputItem
              placeholder="请输入姓名"
              {...getFieldProps("nickName", {
                rules: [{ required: true }],
              })}
              onBlur={fixIOSWXBug}
              error={getFieldError("nickName")}
            />
            <InputItem
              placeholder="请输入身份证号"
              {...getFieldProps("idNumber", {
                rules: [{ required: true, len: 18 }],
              })}
              onBlur={fixIOSWXBug}
              error={getFieldError("idNumber")}
            /> */}
          </List>
          <Button
            className="register__register-btn"
            type="primary"
            onClick={this.handleSubmit}
          >
            注册
          </Button>
          <div style={{ color: "#BBBBBB", marginTop: "5%", marginLeft: "2%" }}>
            点击注册即视为您已经阅读并同意《招聘助手使用协议》
          </div>
        </div>
      </div>
    );
  }
}

export default createForm()(Register);
